import { render, staticRenderFns } from "./PwaInstallAwardPopup.vue?vue&type=template&id=122b92ee&scoped=true&"
import script from "./PwaInstallAwardPopup.vue?vue&type=script&lang=js&"
export * from "./PwaInstallAwardPopup.vue?vue&type=script&lang=js&"
import style0 from "./PwaInstallAwardPopup.vue?vue&type=style&index=0&id=122b92ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122b92ee",
  null
  
)

export default component.exports